<proffeo-ui-dialog [hideDefaultTitle]="true">
  <div
    dialog-header
    class="flex flex-col gap-1"
  >
    @if (selectionMode === SelectMode.SINGLE) {
      <h2 class="text-lg font-semibold">
        {{ 'select-groups-modal.single-title' | translate }}
      </h2>
    } @else {
      <h2 class="text-lg font-semibold">
        {{ 'select-groups-modal.multi-title' | translate }}
      </h2>
    }
  </div>

  <div class="flex h-full min-h-0 w-full max-w-full flex-col gap-3">
    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="w-full shrink-0"
    >
      <mat-icon
        fontIcon="search"
        matPrefix
        class="icon-muted"
      />
      <input
        (input)="onSearchInput($event)"
        [value]="search()"
        [placeholder]="'select-groups-modal.search-placeholder' | translate"
        matInput
      />
    </mat-form-field>

    <div class="min-h-0 flex-1 overflow-y-auto rounded-md border border-proffeo-border/80">
      @for (root of displayGroups(); track root.id) {
        <proffeo-select-groups-tree-node
          [group]="root"
          [depth]="0"
          [selectionMode]="selectionMode"
          [allowHierarchy]="allowHierarchy"
          [searchLower]="searchLower()"
          [lockedIds]="lockedIds()"
          [expandedIds]="expandedIds"
          [selectedIds]="selectedIds"
        />
      }
      @if (displayGroups().length === 0) {
        <p class="p-4 text-sm">{{ 'placeholders.no-results-found' | translate }}</p>
      }
    </div>
  </div>

  <div
    dialog-actions
    class="flex w-full flex-wrap items-center justify-between gap-3 bg-proffeo-surface-muted/90 py-2"
  >
    <div class="flex min-w-0 flex-col gap-0.5">
      @if (selectionMode === SelectMode.SINGLE) {
        <span class="text-xs uppercase tracking-wide text-proffeo-muted">
          {{ 'select-groups-modal.footer-single-label' | translate }}
        </span>
        <span class="truncate font-semibold">
          @if (firstSelectedGroupName()) {
            {{ firstSelectedGroupName() }}
          } @else {
            {{ 'select-groups-modal.footer-single-empty' | translate }}
          }
        </span>
      } @else {
        <span class="text-sm text-proffeo-text">
          {{ 'select-groups-modal.footer-multi-summary' | translate: { count: selectedCount() } }}
        </span>
      }
    </div>
    <div class="flex shrink-0 items-center gap-2">
      <proffeo-ui-button
        (clicked)="cancel()"
        text="common.cancel"
        variant="ghost"
      />
      <proffeo-ui-button
        (clicked)="confirm()"
        text="select-groups-modal.save-changes"
        variant="accent"
      />
    </div>
  </div>
</proffeo-ui-dialog>
